var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#DA1E28",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3493 8.0001C14.3493 11.5347 11.4839 14.4001 7.94932 14.4001C4.41469 14.4001 1.54932 11.5347 1.54932 8.0001C1.54932 4.46547 4.41469 1.6001 7.94932 1.6001C11.4839 1.6001 14.3493 4.46547 14.3493 8.0001ZM7.18932 5.6001L7.14932 4.4001H8.74932L8.70932 5.6001L8.50932 8.8001H7.38932L7.18932 5.6001ZM7.94932 11.6001C8.39114 11.6001 8.74932 11.2419 8.74932 10.8001C8.74932 10.3583 8.39114 10.0001 7.94932 10.0001C7.50749 10.0001 7.14932 10.3583 7.14932 10.8001C7.14932 11.2419 7.50749 11.6001 7.94932 11.6001Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.56486e12415907b990b00119a6842194.svg";
export { ForwardRef as ReactComponent };